import {Component} from "react";
import simplyContext from "../../../../settings/state/simply";
import withRouter from "../../../main/withRouter"
import {funcNavigate} from "../../../../settings/utils/functions";
import {Helmet, HelmetProvider} from "react-helmet-async";
import {header} from "../../components/header";
import {slider} from "../components/slider";
import {news} from "../components/news";
import {footer} from "../../components/footer";
import {mahsoolatJadid} from "../components/mahsoolatJadid";
import {marjaiat} from "../components/marjaiat";
import {mahsoolatAmoozeshi} from "../components/mahsoolatAmoozeshi";
import {hekmatBonyan} from "../components/hekmatBonyan";
import {pezeshkKhanevade} from "../components/pezeshkKhanevade";
import {heyatElmi} from "../components/heyatElmi";
import {eghtesadModiriat} from "../components/eghtesadModiriat";
import {nezameAliSalamat} from "../components/nezameAliSalamat";
import {modiriatBimarestani} from "../components/modiriatBimarestani";
import {mohajeratNokhbegan} from "../components/mohajeratNokhbegan";
import {corona} from "../components/corona";
import {moarefi} from "../components/moarefi";
import {Charts} from "../components/charts";
import {amoozeshSalamat} from "../components/amoozeshSalamat";
import {noavar} from "../components/noavar";
import {NavLink} from "react-router-dom";
import {urlDynamic} from "../../../../settings/utils/urlDynamic";
import Carousel from "react-multi-carousel";

class Home extends Component {
    static contextType = simplyContext

    componentDidMount() {
        this.context.fHome()
    }


    componentDidUpdate(prevProps, prevState, snapshot) {
        funcNavigate(this.props.navigate, this.context)
    }

    render() {
        return (
            <HelmetProvider>
                <Helmet>
                    <title>صفحه اصلی | مرکز ملی تحقیقات راهبردی آموزش علوم پزشکی (نصر)</title>
                    <link rel="canonical" href="https://nasrme.ac.ir"/>
                </Helmet>
                {this.context.state.sHome !== null ? (
                    <div className='container-fluid cFlex1 cBg3'>

                        {header(this.context)}

                        {this.context.state.sHome.slider.length > 0 ? (
                            slider(this.context)
                        ) : null}

                        {moarefi(this.context)}


                        {this.context.state.sHome.akhbar.length > 0 ? (
                            news(this.context)
                        ) : null}

                        <Charts/>

                        {this.context.state.sHome.mahsoolatJadid.length > 0 ? (
                            mahsoolatJadid(this.context)
                        ) : null}


                        {this.context.state.sHome.marjaiat.length > 0 ? (
                            marjaiat(this.context)
                        ) : null}

                        {this.context.state.sHome.hekmatBonyan.length > 0 ? (
                            hekmatBonyan(this.context)
                        ) : null}

                        {this.context.state.sHome.noavarVaKarafarin.length > 0 ? (
                            noavar(this.context)
                        ) : null}

                        {mahsoolatAmoozeshi()}


                        {this.context.state.sHome.pezeshkKhanevade.length > 0 ? (
                            pezeshkKhanevade(this.context)
                        ) : null}

                        {this.context.state.sHome.heyatElmi.length > 0 ? (
                            heyatElmi(this.context)
                        ) : null}

                        {this.context.state.sHome.eghtesadModiriat.length > 0 ? (
                            eghtesadModiriat(this.context)
                        ) : null}


                        {this.context.state.sHome.nezameAliSalamat.length > 0 ? (
                            nezameAliSalamat(this.context)
                        ) : null}


                        {this.context.state.sHome.amoozeshSalamat.length > 0 ? (
                            amoozeshSalamat(this.context)
                        ) : null}


                        {this.context.state.sHome.mohajeratNokhbegan.length > 0 ? (
                            mohajeratNokhbegan(this.context)
                        ) : null}


                        {this.context.state.sHome.corona.length > 0 ? (
                            corona(this.context)
                        ) : null}

                        {this.context.state.sHome.modiriatBimarestani.length > 0 ? (
                            modiriatBimarestani(this.context)
                        ) : null}

                        <div className='row p-5  position-relative cPx1 justify-content-center position-relative'>
                            <div
                                className="position-absolute cShadow1 cShadow2 d-none d-lg-flex justify-content-center align-items-center"></div>
                            <div
                                className="position-absolute cShadow1 cShadow3 d-none d-lg-flex justify-content-center align-items-center"></div>
                            <div className='cContainer col-12'>
                                <div className='row justify-content-center'>
                                    <div className='col-12 col-md-6 col-lg-3'>
                                        <div>
                                            <NavLink to='/مسیحادم' target={"_blank"}
                                                     className="cHover7 card position-relative overflow-hidden rounded-0 h-100 rounded rounded-4 border">
                                                <img src='/images/2223.webp' width="360" height='550'
                                                     className="img-fluid w-100"
                                                     alt="تصویر"/>
                                            </NavLink>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                        {footer(true)}

                    </div>
                ) : null}

            </HelmetProvider>
        )
    }
}

export default withRouter(Home)